import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendRequest,
  updateData,
  selectIdentifier,
  requestInProcess,
  requestFinished
} from '../../../../../../common/reducers/data/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksService from '../../../../services/TasksService';

function* getTaskAsExec(reducerName) {
  const identifier = yield select(selectIdentifier, reducerName);
  let status = null;
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(
      timeoutCall,
      TasksService.getTaskAsExec,
      identifier
    );
    if (result.response) {
      if (result.response.status === 200) {
        yield put(updateData(reducerName, result.destructData));
      }
    }
    status = result.response.status;
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [takeEvery(sendRequest(reducerName).type, getTaskAsExec, reducerName)];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/views/sagas/taskViewAsExecutorSaga.js